import { Flex } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useMemo, useRef } from 'react';
import {
  clearResultsAction,
  setSearchAction,
} from 'app/store/GlobalSearch/slice';
import {
  getGlobalSearchByCollaborator,
  getSearchValue,
} from 'app/store/GlobalSearch/selectors';
import { getAvatarImage } from 'app/utils/utils';
import { ExpandingInput } from '../ExpandingInput';

export const GLOBAL_SEARCH_INPUT_ID = 'global-search-input';

export const GlobalSearchInput = () => {
  const dispatch = useAppDispatch();

  const rootRef = useRef<HTMLDivElement>(null);

  const searchValue = useAppSelector(getSearchValue);
  const searchByCollaborator = useAppSelector(getGlobalSearchByCollaborator);

  const handleOnChange = (search: string) => {
    if (search === '' && !searchByCollaborator) {
      dispatch(clearResultsAction());
    }
    dispatch(setSearchAction(search));
  };

  const searchTag = useMemo(() => {
    if (!searchByCollaborator) {
      return undefined;
    }
    return {
      guid: searchByCollaborator.guid,
      displayName: searchByCollaborator.displayName,
      imageSrc: getAvatarImage(searchByCollaborator.profileImages),
      colors: searchByCollaborator?.avatarColors,
    };
  }, [searchByCollaborator]);

  return (
    <Flex
      id={GLOBAL_SEARCH_INPUT_ID}
      w="full"
      justify="flex-end"
      ref={rootRef}
      height="38px"
      mr={4}
    >
      {rootRef.current && (
        <ExpandingInput
          rootElement={rootRef.current}
          inputWidth={searchValue || searchTag ? 540 : 244}
          search={searchValue}
          tag={searchTag}
          onChange={(value) => handleOnChange(value.trim())}
          onClear={() => dispatch(clearResultsAction())}
        />
      )}
    </Flex>
  );
};
